// extracted by mini-css-extract-plugin
export default {"label":"FKxsMgedIv1TPsFZosUi","icon":"c8onI0CFCI5LDZBEAOeZ"};